.container {
  max-width: var(--mirai-ui-breakpoint-content);
  padding: var(--mirai-ui-space-M);
}
